<div class="modal-dialog modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">Szűrők beállítása</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<%- include('/ui/form', {
				params: [ 'search_modal', Anvil.page.search ],
				fields: [
					{
						type: 'text',
						name: 'expression',
						title: 'Szöveges keresés',
						attributes: {
							placeholder: 'Keresés...'
						},
						append: '<span class="input-group-text"><i class="fa fa-fw fa-search"></i></span>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'archive',
						title: 'Státusz',
						params: {
							maxItems: 1,
							options: [
								{ value: 0, label: 'Élő', icon: 'clipboard-check', color: 'text-success' },
								{ value: 1, label: 'Archív', icon: 'archive', color: 'text-warning' }
							],
							valueField: 'value',
							labelField: 'label',
							render: {
								item: (item, esc) => `<div><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`,
								option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`
							},
							placeholder: '[ minden státusz ]'
						},
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.archive = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'company_group_id',
						title: 'Cég csoport',
						params: {
							maxItems: 1,
							options: [ { id: -1, name: '[ csoporton kívüli ]' }, ...Anvil.page.company_groups.data ],
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}</div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
							},
							placeholder: '[ minden cégcsoport ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.company_group_id = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'referer_id',
						title: 'Ajánló',
						params: {
							maxItems: 1,
							options: [ { id: -1, name: '[ nincs ajánló ]' }, ...Anvil.page.companies.data.filter(x => x.referer == 1) ],
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'name', 'tax_number' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}</div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
							},
							placeholder: '[ minden ajánló ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.referer_id = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'distributor_id',
						title: 'Disztribútor',
						params: {
							maxItems: 1,
							options: [ { id: -1, name: '[ nincs disztribútor ]' }, ...Anvil.page.companies.data.filter(x => x.distributor == 1) ],
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'name', 'tax_number' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}</div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
							},
							placeholder: '[ minden disztribútor ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.distributor_id = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'platform',
						title: 'Platform',
						params: {
							maxItems: 1,
							options: [
								{ value: 'android' , label: 'Android', icon: 'fab fa-android', color: 'text-success' },
								{ value: 'windows' , label: 'Windows', icon: 'fa fa-desktop', color: 'text-primary' }
							],
							valueField: 'value',
							labelField: 'label',
							searchField: [ 'name' ],
							render: {
								item: (item, esc) => `<div><i class="fa-fw ${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`,
								option: (item, esc) => `<div class="option"><i class="fa-fw ${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`
							},
							placeholder: '[ minden platform ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.platform = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'update_channel',
						title: 'Frissítési csatorna',
						params: {
							maxItems: 1,
							options: [
								{ value: 'alpha' , label: 'Alfa', color: 'text-danger' },
								{ value: 'beta' , label: 'Béta', color: 'text-warning' },
								{ value: 'stable' , label: 'Stabil', color: 'text-success' },
								{ value: 'disabled' , label: 'Ne frissüljön', color: 'text-secondary' }
							],
							valueField: 'value',
							labelField: 'label',
							searchField: [ 'name' ],
							render: {
								item: (item, esc) => `<div><i class="fa fa-fw fa-sm fa-circle me-2 ${item.color}"></i>${esc(item.label)}</div>`,
								option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-sm fa-circle me-2 ${item.color}"></i>${esc(item.label)}</div>`
							},
							placeholder: '[ minden frissítési csatorna ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.update_channel = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					},
					{
						type: 'select',
						name: 'bct_driver',
						title: 'Kártyás fiz. szolg.',
						params: {
							maxItems: 1,
							options: [
								{ value: -1, label: '[ nincs szolgáltató ]' },
								{ value: 'novo' , label: 'Novopayment (LAN)' },
								{ value: 'novo2' , label: 'Novopayment (Felhő)' },
								{ value: 'teya' , label: 'Teya' },
							],
							valueField: 'value',
							labelField: 'label',
							searchField: [ 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.label)}</div>`,
								option: (item, esc) => `<div class="option">${esc(item.label)}</div>`
							},
							placeholder: '[ bármely szolgáltató ]'
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.bct_driver = null;"><i class="fa fa-fw fa-times"></i></button>',
						update: (value) => {
							Anvil.page.quickSearch()
						}
					}
				]
			}) %>
		</div>
	</div>
</div>
